import { useNavigate, Outlet } from "react-router-dom";
import { useEffect } from "react";
import { setNavigate } from "../utils/navigator";

export default function NavigateProvider() {
  const navigate = useNavigate();

  useEffect(() => {
    setNavigate(navigate);   
  }, [navigate]);

  return <Outlet />;   
}
